import React, { useContext, useState } from "react";
import LoginView from "../../views/auth/LoginView";
import { Request as RequestLogin } from "../../api/auth/Login.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useHistory } from "react-router";
import { AuthContextDispatchContext } from "../../context/auth/AuthContext";

const initialValues = {
  username: "",
  password: "",
};

const LoginContainer = ({ type }) => {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { setToken } = useContext(AuthContextDispatchContext);

  const onSubmitLogin = ({ username, password }, actions) => {
    setError(null);
    setLoading(true);
    RequestLogin.login({
      username,
      password,
    })
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setToken(data);
    history.push("/app/dashboard");
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };

  return (
    <>
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      <LoginView onSubmit={onSubmitLogin} initialValues={initialValues} />
    </>
  );
};

export default LoginContainer;
